import { useTranslation } from 'react-i18next';
import { homeGoals } from '@/mocks/home';

export default function Goals() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'kk';

  const isEn = lang.startsWith('en');
  const isRu = lang.startsWith('ru');

  return (
    <section id="goals" className="relative bg-background-900 overflow-hidden">
      <div className="absolute inset-0 tactical-grid opacity-10 pointer-events-none" />

      {/* Side image for large screens */}
      <div className="absolute top-0 right-0 w-1/3 h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=Kazakh%20East%20Asian%20Mongoloid%20young%20man%20athlete%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20military%20camouflage%20competition%20uniform%20arms%20crossed%20confident%20proud%20posture%20standing%20outdoors%20dramatic%20cinematic%20portrait%20side%20lighting%20warm%20amber%20highlights%20dark%20near-black%20shadows%20muted%20olive%20sand%20tones%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=600&height=900&seq=goals-kz-v4&orientation=portrait&nocache=true"
          alt="Athlete"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-900 via-background-900/60 to-transparent" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 lg:py-32">
        <div className="max-w-3xl">
          {/* Section header */}
          <div className="mb-10 md:mb-14">
            <div className="section-label mb-4">
              {isEn ? 'Goals & Mission' : isRu ? 'Цели и задачи' : 'Мақсаттар мен міндеттер'}
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 uppercase tracking-tight leading-tight">
              {isEn ? 'Federation' : isRu ? 'Цели' : 'Федерацияның'}
              <span className="text-accent-500">{isEn ? ' Goals' : isRu ? ' Федерации' : ' мақсаттары'}</span>
            </h2>
          </div>

          {/* Goals list */}
          <div className="space-y-5 md:space-y-6">
            {homeGoals.map((goal, index) => {
              const text = isEn ? goal.textEn : isRu ? goal.textRu : goal.textKk;
              return (
                <div
                  key={goal.id}
                  className="flex gap-4 md:gap-5 items-start group"
                >
                  {/* Number marker */}
                  <div className="flex-shrink-0 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center border border-accent-500/20 group-hover:border-accent-500/50 bg-background-800/30 transition-all duration-300">
                    <span className="font-heading text-accent-500 text-sm md:text-base font-bold">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>

                  {/* Text */}
                  <div className="pt-1.5 md:pt-2">
                    <p className="text-foreground-300 text-sm md:text-base leading-relaxed">
                      {text}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-accent-500/20 to-transparent" />
    </section>
  );
}